import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import { Notification } from "@/Components";
import { NEST_BACKEND_URL } from "@/lib/axios";
import { axiosApi } from "@/Utils";
import { ThemeMode } from "@/Utils/Colors/Theme";

interface UpdateThemeResponse {
  success: boolean;
  theme: ThemeMode;
}

export const updateTheme = async (mode: ThemeMode): Promise<AxiosResponse<UpdateThemeResponse>> => {
  const response = await axiosApi.put(
    `/api/settings/theme`,
    {
      theme: mode,
    },
    {
      baseURL: NEST_BACKEND_URL,
    }
  );
  return response;
};

export const useUpdateTheme = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateTheme,
    onSuccess: () => {
      Notification("success", "Theme updated successfully.");
      // Invalidate any theme-related queries if they exist
      queryClient.invalidateQueries({ queryKey: ["theme"] });
    },
    onError: (error) => {
      Notification("error", "Failed to update theme.");
      console.error("Update theme error:", error);
    },
  });
};
